import React from 'react';
import { FormattedMessage } from 'react-intl';
import FieldOrNoData from '~/features/base/components/FieldOrNoData';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';
import { DOWNLOAD_TYPE_MULTIPLE, STATUS_DOWNLOADED } from '~/features/deliverables/constants/DownloadFile';

interface DownloadTypeDisplayProps {
    downloadType?: string;
    downloadStatus?: string;
}

const DownloadTypeDisplay: React.FC<DownloadTypeDisplayProps> = ({
    downloadType,
    downloadStatus
}) => {
    return (
        <FieldOrNoData
            field={downloadType && (
                <div className='display-flex align-items-center'>
                    <FormattedMessage
                        id={downloadType === DOWNLOAD_TYPE_MULTIPLE ? 'intl-msg:yes' : 'intl-msg:no'}
                    />
                    {downloadStatus === STATUS_DOWNLOADED && (
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip id='tooltip' className='top-right'>
                                    <FormattedMessage id='intl-msg:downloadStatus:downloaded'/>
                                </Tooltip>
                            }
                        >
                            <span className='rioglyph rioglyph-ok rioglyph-filled margin-left-5'/>
                        </OverlayTrigger>
                    )}
                </div>
            )}
        />
    );
};

export default DownloadTypeDisplay;